<template>
    <v-chip class="button1 text-left" style="cursor: default;" elevation="4" variant="outlined" rounded="xl"
        :color="color ? color : 'transparent'" :closable="closable" @click:close="handleClose">
        {{ title }}
    </v-chip>
</template>
<script>
export default {
    name: 'chipsButton',
    props: {
        title: {
            type: String,
            default: null,
        },
        color: {
            default: null,
        },
        closable: {
            default: false
        },
        clickClose: {
            type: Function,
            default: null
        },
        tagIndex: {
            type: Number,
            required: true
        }
    },
    methods: {
        handleClose() {
            if (this.clickClose) {
                this.clickClose(this.tagIndex);
            }
        }
    }
}
</script>
<style>
.button1 {
    color: white;
    font-family: Inter;
    font-size: 12px;
    font-weight: 500;
    line-height: 15px;
    letter-spacing: 0.01em;
    text-align: left;
    border: 5px;
    border-color: black;
}
</style>